import { render, staticRenderFns } from "./ProductFeedback.vue?vue&type=template&id=82679528&"
import script from "./ProductFeedback.vue?vue&type=script&lang=js&"
export * from "./ProductFeedback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports